import { Layout } from '@/components/Layout';
import { Stack, SxProps, Theme } from '@mui/material';
import { Button } from 'ui-kit';
import { H1 } from '@/components/H1';
import { H2 } from '@/components/H2';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/Text';
import { useOptOut } from '@/store/hooks';

export const IndexPage = () => {
  const { t } = useTranslation();
  const { email, step, showContent, isLoading, optOut, choseNotToOptOut } =
    useOptOut();

  if (!showContent) {
    return null;
  }

  const header = <H1 sx={layoutStyles.h1}>{t('OPT_OUT_CONFIRMATION_FORM')}</H1>;

  const renderStartPage = () => {
    return (
      <>
        <Stack sx={layoutStyles.contentBody}>
          {header}
          <H2 sx={layoutStyles.h2}>
            {t('SWITCH_TO_LINK_ONLY_DELIVERY_MODE_FOR_', { email })}
          </H2>
          <Text>{t('BY_SUBMITTING_YOU_CONFIRM_THAT_YOU_OPT_OUT_OF_')}</Text>
        </Stack>
        <Stack sx={layoutStyles.buttonsFooter}>
          <Button
            variant={'outlined'}
            color={'secondary'}
            data-test-id={'opt-out-service_decision-page_cancel-button'}
            onClick={choseNotToOptOut}
            disabled={isLoading}
          >
            {t('CANCEL')}
          </Button>
          <Button
            variant={'contained'}
            color={'secondary'}
            data-test-id={'opt-out-service_decision-page_confirm-button'}
            onClick={optOut}
            disabled={isLoading}
          >
            {t('CONFIRM')}
          </Button>
        </Stack>
      </>
    );
  };

  const renderOptedOut = () => {
    return (
      <>
        <Stack sx={layoutStyles.contentBody}>
          {header}
          <Text>
            {t('YOUR_OPT_OUT_REQUEST_HAS_BEEN_SUCCESSFULLY_PROCESSED_')}
          </Text>
        </Stack>
      </>
    );
  };

  const renderCancelled = () => {
    return (
      <>
        <Stack sx={layoutStyles.contentBody}>
          {header}
          <Text>
            {t(
              'YOU_HAVE_CANCELLED_THE_REQUEST_TO_OPT_OUT_OF_RECEIVING_ATTACHMENTS_'
            )}
          </Text>
        </Stack>
      </>
    );
  };

  let content = <></>;
  switch (step) {
    case 'init':
      content = renderStartPage();
      break;
    case 'decided-not-to-opt-out':
      content = renderCancelled();
      break;
    case 'opted-out':
      content = renderOptedOut();
      break;
  }

  return <Layout sx={layoutStyles.layout}>{content}</Layout>;
};

const layoutStyles = {
  h1: { mb: { xs: 36, sm: 60, lg: 60 } },
  h2: { mb: { xs: 12 } },
  contentBody: {
    mb: { lg: 60 },
  },
  buttonsFooter: {
    flexDirection: { xs: 'column-reverse', lg: 'row' },
    gap: { xs: 12, sm: 18, lg: 24 },
  },
  layout: {
    div: {
      justifyContent: { xs: 'space-between', lg: 'initial' },
    },
  },
} satisfies Record<string, SxProps<Theme>>;
